import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { _ } from '@ngx-translate/core';

export const FpLoggerNoiseTabsLocalize = {
  [FpLoggerNoiseTabs.Histogram]: _('@@leak-detection-histogram'),
  [FpLoggerNoiseTabs.SignalSpectrum]: _('@@leak-detection-signal-spectrum'),
  [FpLoggerNoiseTabs.LeakScore]: _('@@shared-leak-score__text'),
  [FpLoggerNoiseTabs.AIPredictor]: _('@@shared-ai-predictor__text'),
  [FpLoggerNoiseTabs.MinNoise]: _('@@shared-min-noise__text'),
  [FpLoggerNoiseTabs.Spread]: _('@@shared-spread__text'),
  [FpLoggerNoiseTabs.Summary]: _('@@shared-summary'),
  [FpLoggerNoiseTabs.Comments]: _('@@shared-comments'),
  [FpLoggerNoiseTabs.Pictures]: _('@@leak-detection-picture'),
};
